import React from "react";
import COLORS from "../theme/colors";

/** A true/false value as a small "Da" / "Ne" chip instead of "true" / "false". */
const YesNoField = ({ record = {}, source }) => {
  const yes = record[source] === true || record[source] === "true";
  return (
    <span
      style={{
        display: "inline-block",
        padding: "3px 10px",
        borderRadius: 999,
        backgroundColor: yes ? COLORS.successLight : COLORS.neutralLight,
        color: yes ? COLORS.success : COLORS.neutral,
        fontSize: 12,
        fontWeight: 600
      }}
    >
      {yes ? "Da" : "Ne"}
    </span>
  );
};

YesNoField.defaultProps = { addLabel: true };

export default YesNoField;
